import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/shopcart/orderSuccess.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "flow" }
const _hoisted_5 = { class: "f1" }
const _hoisted_6 = { class: "flow-head" }
const _hoisted_7 = { style: {"display":"flex","width":"100%"} }
const _hoisted_8 = { class: "flow-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_10 = { class: "flow-content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_12 = { class: "flow-content" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_14 = { class: "f2" }
const _hoisted_15 = { class: "flow-head" }
const _hoisted_16 = { class: "flow-content" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_18 = { class: "f3" }
const _hoisted_19 = { class: "flow-head" }
const _hoisted_20 = { class: "flow-content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_22 = { class: "f4" }
const _hoisted_23 = { class: "flow-head" }
const _hoisted_24 = { class: "flow-content last" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_26 = { class: "btns" }
const _hoisted_27 = { class: "right-btns" }

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { useRtfix } from '@/store'
// useRtfix


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const visible = ref(false)

const data=ref()

const open = (_data:any) => {
  data.value=_data
  visible.value = true
}
const close = () => (visible.value = false)

expose({
  open,
  close
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    "close-on-click-modal": false,
    "custom-class": "order-success-dialog"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('下单成功2')), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(t)('请及时留意订单发货情况。商品到达仓库后，您可创建国际发货单，将商品发送至您的地址。')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('CKB执行')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(SvgIcon, { name: "orderflow1" }),
                _hoisted_9,
                _createElementVNode("div", null, _toDisplayString(_unref(t)('采购')), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(SvgIcon, { name: "orderflow2" }),
                _hoisted_11,
                _createElementVNode("div", null, _toDisplayString(_unref(t)('CKB仓库')), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(SvgIcon, { name: "orderflow3" }),
                _hoisted_13,
                _createElementVNode("div", null, _toDisplayString(_unref(t)('检品上架')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('用户执行')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(SvgIcon, { name: "orderflow4" }),
              _hoisted_17,
              _createElementVNode("div", null, _toDisplayString(_unref(t)('创建国际发货单')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('CKB执行')), 1),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(SvgIcon, { name: "orderflow5" }),
              _hoisted_21,
              _createElementVNode("div", null, _toDisplayString(_unref(t)('运输')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('用户执行')), 1),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(SvgIcon, { name: "orderflow6" }),
              _hoisted_25,
              _createElementVNode("div", null, _toDisplayString(_unref(t)('收货')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_router_link, {
            class: "left-btn",
            to: _unref(useRtfix)('ShippingList')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('如何创建国际发货单？')), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_el_button, { onClick: close }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('留在购物车')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$router.push(_unref(useRtfix)('OrderInfo', { params: { id: data.value[0]?.platformOrderId } })); close()}),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('查看订单')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})